import { atelierWert, atelierZeilen } from "./typen.js";
/** Ganze Euro oder mit Komma bzw. Punkt und höchstens zwei Nachkommastellen – kein Tausenderpunkt. */
const DEZIMAL = /^\d+([.,]\d{1,2})?$/;
export function centAlsText(cent) {
    return (cent / 100).toFixed(2).replace(".", ",");
}
const prozentAlsText = (wert) => String(wert).replace(".", ",");
/** Cent aus „9,81“ bzw. „9.81“; null, wenn unlesbar oder über 9.999,99 €. */
export function atelierCentAus(text) {
    const t = text.trim();
    if (!DEZIMAL.test(t))
        return null;
    const cent = Math.round(Number(t.replace(",", ".")) * 100);
    return cent <= 999_999 ? cent : null;
}
/** Prozent aus „12,5“; null, wenn unlesbar oder über 999,99. */
export function atelierProzentAus(text) {
    const t = text.trim();
    if (!DEZIMAL.test(t))
        return null;
    const prozent = Math.round(Number(t.replace(",", ".")) * 100) / 100;
    return prozent <= 999.99 ? prozent : null;
}
function zahlAus(text) {
    const t = text.trim();
    if (!/^\d+$/.test(t))
        return null;
    const zahl = Number(t);
    return zahl <= 9999 ? zahl : null;
}
/** Formularwerte aus der gespeicherten Liste; ohne Liste die Startwerte des Moduls. */
export function atelierpreiseAlsEingaben(modul, preise) {
    const p = preise ?? modul.startwerte;
    const werte = {};
    for (const z of atelierZeilen(modul)) {
        const wert = atelierWert(modul, p, z.schluessel);
        werte[z.schluessel] = z.art === "geld" ? centAlsText(wert) : prozentAlsText(wert);
    }
    return {
        stand: p.stand,
        mindermengeProzent: prozentAlsText(p.mindermengeProzent),
        uvpAufschlagProzent: prozentAlsText(p.uvpAufschlagProzent),
        werte,
        uvpVonHand: Object.fromEntries(Object.entries(p.uvpVonHand).map(([k, cent]) => [k, centAlsText(cent)])),
    };
}
/** Liest das Formular. Ein einziger Fehler → keine Preisliste, dafür jeder Fehler an seinem Feld. */
export function atelierpreiseAusEingaben(modul, e) {
    const fehler = {};
    const stand = e.stand.trim();
    if (!/^\d{4}-\d{2}-\d{2}$/.test(stand))
        fehler.stand = "Datum der Preisliste eintragen.";
    const mindermenge = atelierProzentAus(e.mindermengeProzent);
    if (mindermenge === null)
        fehler.mindermengeProzent = "0 bis 999,99 %.";
    const uvpAufschlag = atelierProzentAus(e.uvpAufschlagProzent);
    if (uvpAufschlag === null)
        fehler.uvpAufschlagProzent = "0 bis 999,99 %.";
    const werte = {};
    for (const z of atelierZeilen(modul)) {
        const text = e.werte[z.schluessel] ?? "";
        const wert = z.art === "geld" ? atelierCentAus(text) : z.art === "prozent" ? atelierProzentAus(text) : zahlAus(text);
        if (wert !== null)
            werte[z.schluessel] = wert;
        else
            fehler[z.schluessel] = z.art === "geld" ? "Betrag von 0 bis 9.999,99 €." : z.art === "prozent" ? "0 bis 999,99 %." : "Ganze Zahl von 0 bis 9.999.";
    }
    const uvpVonHand = {};
    for (const [schluessel, text] of Object.entries(e.uvpVonHand)) {
        const cent = atelierCentAus(text);
        if (cent !== null)
            uvpVonHand[schluessel] = cent;
        else
            fehler[`uvp:${schluessel}`] = "Betrag von 0 bis 9.999,99 €.";
    }
    if (Object.keys(fehler).length > 0 || mindermenge === null || uvpAufschlag === null)
        return { preise: null, fehler };
    return {
        preise: {
            modell: modul.schluessel,
            version: modul.version,
            stand,
            mindermengeProzent: mindermenge,
            uvpAufschlagProzent: uvpAufschlag,
            werte,
            uvpVonHand,
        },
        fehler,
    };
}
//# sourceMappingURL=eingaben.js.map